export enum PhoneType {
  Mobile = 0, // 'Mobile',
  Landline = 1, // 'Landline',
  Unconfirmed = 2, // 'Unconfirmed',
  Unknown = 3, // 'Unknown'
}
